import isType from "./isType";

const isRegExp = value => isType(value, "RegExp");

export default isRegExp;
//# sourceMappingURL=isRegExp.js.map